export interface ScriptNumberModel {
    media: string;
    fromNumber: string;
    toNumber: string;
}
